import { useSelector, useDispatch } from "react-redux";
import SoundsOn from "../../../images/SoundsOn.webp";
import SoundsOff from "../../../images/SoundsOff.webp";
import { setIsSoundEffectsMute } from "../../../redux/slices/soundsSlice";
import styles from "./SoundEffectMuter.module.css";

const SoundEffectMuter = () => {
  const sounds = useSelector((state) => state.sounds);
  const dispatch = useDispatch();

  const toggleSoundinRedux = () => {
    dispatch(setIsSoundEffectsMute(!sounds.isSoundEffectsMute));
  };
  return (
    <div>
      {sounds.isSoundEffectsMute ? (
        <img
          src={SoundsOff}
          alt="SoundsOff"
          draggable={false}
          className={styles.soundImage}
          onClick={toggleSoundinRedux}
        />
      ) : (
        <img
          src={SoundsOn}
          alt="SoundsOn"
          draggable={false}
          className={styles.soundImage}
          onClick={toggleSoundinRedux}
        />
      )}
    </div>
  );
};

export default SoundEffectMuter;
